import { ClientService } from '@vi-iot/client';
import { Observable } from 'rxjs';
import { httpHeaders } from '@vi-iot/client/client.service';
import { Injectable } from '@angular/core';
import { SmartHomeComponent } from '@vi-iot/client/apis/smart-home-components/smart-home-components.model';

@Injectable()
export class SmartHomeComponentsApi {
  constructor(private clientService: ClientService) {}

  /**
   * Get smart home components
   * @param installationId: number
   */
  listSmartHomeComponents(installationId: number): Observable<{ data: SmartHomeComponent[] }> {
    const endpoint = `iot/v2/equipment/installations/${installationId}/smartComponents`;

    return this.clientService.get(endpoint, {}, httpHeaders);
  }

  /**
   * Update smart home components
   * @param installationId: number
   * @param smartHomeComponents: SmartHomeComponent[]
   */
  updateSmartHomeComponents(
    installationId: number,
    smartHomeComponents: SmartHomeComponent[]
  ): Observable<{ data: SmartHomeComponent[] }> {
    const endpoint = `iot/v2/equipment/installations/${installationId}/smartComponents`;

    return this.clientService.put(
      endpoint,
      {
        selected: [...smartHomeComponents.filter((shc) => shc.selected).map((shc) => shc.id)],
      },
      httpHeaders
    );
  }
}
